import { Controller } from "@hotwired/stimulus"
import { bootArchipelagoIslands } from "@archipelago-js/react"
import registry from "../archipelago/registry.generated"

export default class extends Controller {
  static targets = ["container", "label"]
  static values = {
    leftText: String,
    rightText: String,
    leftLabel: String,
    rightLabel: String,
    language: { type: String, default: "json" }
  }

  toggle() {
    const container = this.containerTarget
    const isShowing = container.children.length > 0

    if (isShowing) {
      container.innerHTML = ""
      container.classList.add("hidden")
      if (this.hasLabelTarget) {
        this.labelTarget.textContent = "View raw diff"
      }
    } else {
      const island = document.createElement("div")
      island.setAttribute("data-island", "true")
      island.setAttribute("data-component", "RawDiffViewer")
      island.setAttribute("data-props", JSON.stringify({
        leftText: this.leftTextValue,
        rightText: this.rightTextValue,
        leftLabel: this.leftLabelValue,
        rightLabel: this.rightLabelValue,
        language: this.languageValue
      }))
      island.setAttribute("data-params", "{}")
      island.className = "raw-diff-viewer-island"
      container.appendChild(island)
      container.classList.remove("hidden")
      void bootArchipelagoIslands(registry)
      if (this.hasLabelTarget) {
        this.labelTarget.textContent = "Hide raw diff"
      }
    }
  }
}
